import axios from "axios";
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../../Univ.js'
function EditInsurCmpy(){

    const {id}=useParams();
    const [insur,setInsur] = useState([]);
    const [insurCmpyData,setinsurCmpyData]=useState({
        "type":'',
        "company":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });
    useEffect(() => {
        try{
            axios.get(baseUrl+'edit-insur-cmpy/'+ id +'/')
            .then(function (response) {
                setinsurCmpyData({
                    type:response.data.type.id,
                    company:response.data.company,
                });
            });
        }catch(error){
            console.log(error);
        }
    },[]);
    const handleChange = (event) => {
        setinsurCmpyData({
            ...insurCmpyData,
            [event.target.name]:event.target.value
        });
    }

    const formSubmit = () =>{
        const _formData = new FormData();
        _formData.append('type',insurCmpyData.type);
        _formData.append('company',insurCmpyData.company);
        _formData.append('status','1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
        try{
            axios.put(baseUrl+'edit-insur-cmpy/'+ id + '/', _formData, {
                headers : {
                    'content-type': 'multiple/form-data'
                }
            })
            .then(function (response) {
               if(response.status==200){
                    Swal.fire({
                        title: 'Data has been updated',
                        icon: 'success',
                        timer:3000,
                        showConfirmButton: false
                    });
               }
               setTimeout(() => {
                  window.location.href = ('/insur-cmpy/');
                }, 3000);
            });
            }catch(error){
                console.log(error);
            }
        };

    useEffect(() => {
        try{
            axios.get(baseUrl+'insur-type/')
            .then(function (response) {
                setInsur(response.data);
            });
        }catch(error){
            console.log(error);
        }
        },[]);
    return (
        <section className="container mt-4">
            <div className="row">
              <div className='col-md-9 col-12 mb-2'>
                <div className='card'>
                    <h4 className='card-header'>Edit Insurance Company</h4>
                    <div className='card-body'>
                        <form>
                        <div className="mb-3">
                            <label htmlFor="type_id" className="form-label">Insurance Type</label>
                            <select name="type" value={insurCmpyData.type} onChange={handleChange} className="form-control">
                                {insur.map((type,index) => {return <option key={index} value={type.id}>{type.type}
                                </option>})}
                            </select>
                          </div>
                          <div className="mb-3">
                            <label htmlFor="category" className="form-label">Insurance Company</label>
                            <input type="text" className="form-control" name="company" value={insurCmpyData.company}
                            onChange={handleChange} id="company" />
                          </div>

                          <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                        </form>
                    </div>
                </div>
              </div>
            </div>
        </section>
)
}
export default EditInsurCmpy;